import { z } from 'zod';

export const GlazierFormSchema = z
  .object({
    id: z.string(),
    concurrencyToken: z.string().optional(),
    name: z.string(),
    email: z.string().email('Please enter valid email'),
    phone: z.string(),
    region: z.object({
      id: z.string(),
      name: z.string(),
    }),
    address: z.object({
      placeId: z.string(),
      address: z.string(),
    }),
  })
  .superRefine((data, ctx: any) => {
    if (!data.name || !data.name.trim()) {
      ctx.addIssue({
        path: ['name'],
        message: 'Glazier name is required',
        code: 'custom',
      });
    }

    if (!data.email || !data.email.trim()) {
      ctx.addIssue({
        path: ['email'],
        message: 'Email is required',
        code: 'custom',
      });
    }

    if (!data.phone || !data.phone.trim()) {
      ctx.addIssue({
        path: ['phone'],
        message: 'Phone number is required',
        code: 'custom',
      });
    }

    if (!data.region.id) {
      ctx.addIssue({
        path: ['region'],
        message: 'Region is required',
        code: 'custom',
      });
    }

    if (!data.address.placeId) {
      ctx.addIssue({
        path: ['address'],
        message: 'Address is required',
        code: 'custom',
      });
    }
  });
